import { render, staticRenderFns } from "./InstructionsDialogBox.vue?vue&type=template&id=159f5488&scoped=true"
import script from "./InstructionsDialogBox.vue?vue&type=script&lang=ts"
export * from "./InstructionsDialogBox.vue?vue&type=script&lang=ts"
import style0 from "./InstructionsDialogBox.vue?vue&type=style&index=0&id=159f5488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f5488",
  null
  
)

export default component.exports